import React, { Component } from 'react';
import { Alert, UncontrolledTooltip } from 'reactstrap';
import Moment from 'react-moment';

import { getReservations, requestCubicle } from './../../models/reservation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RoomTiles from './RoomTiles';
import RoomSummary from './room-summary';
import ProgressBar from './../../components/snippets/progress-bar';
import SignalR from './../../components/signalr';
import { getRooms, getCubicles } from './../../models/room';
import { getSections } from './../../models/section';
import { getActiveReception, updateActiveReception, deleteActiveReception } from './../../models/staff';
import NotificationSoundFile from './../../assets/sounds/notification.mp3';
import Loader from './../../components/snippets/loader';
import LanguageSelector from './../../components/language-selector';
import moment from 'moment';
import ReservationDetails from './partials/reservation-details';
import RoomDetails from './partials/room-details';
import { SettingsContext } from '../../components/context';
import Button from './../../components/button';

class ReceptionistMapView extends Component {
  static contextType = SettingsContext;

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoadedRooms: false,
      isLoadedCubicles: false,
      isLoadedReservations: false,
      isLoadedActiveReception: false,
      errorReservations: null,
      modal: false,
      summary: null,
      updatedRooms: null
    };

    this.notificationSound = new Audio(NotificationSoundFile);

    this.retrieveSections = this.retrieveSections.bind(this);
  }

  componentDidMount() {
    this.retrieveReservations();
    this.retrieveRooms();
    if(this.props.siteSettings.useCubicles){
      this.retrieveCubicles();
    }
    this.retrieveSections();
    this.retrieveActiveReception();
    this.setUpTick();
  }

  setUpTick() {
    this.intervalID = setInterval(() => this.setState({time: moment().format()}), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalID);
    clearTimeout(this.sectionRefresh);
  }

  retrieveRooms(updatedRooms) {
    getRooms()
      .then(
        result => {
          let rooms = result;
          let groupedRooms = rooms.reduce(function (r, a) {
            r[a.effectiveStatus] = r[a.effectiveStatus] || [];
            r[a.effectiveStatus].push(a);
            return r;
          },Object.create(null));
          this.setState({
            isLoadedRooms: true,
            rooms: rooms,
            groupedRooms,
            updatedRooms,
            error: null,
          });
          setTimeout(()=>this.setState({updatedRooms:null}),10000)
        },
        error => {
          this.setState({
            isLoadedRooms: true,
            error
          });
        }
      );
  }

  retrieveCubicles() {
    getCubicles()
      .then(
        result => {
          this.setState({
            isLoadedCubicles: true,
            cubicles: result,
            error: null,
          });
        },
        error => {
          this.setState({
            isLoadedCubicles: true,
            error
          });
        }
      );
  }

  retrieveActiveReception() {
    getActiveReception()
      .then(
        result => {
          this.setState({
            isLoadedActiveReception: true,
            activeReception: result
          });
        },
        error => {
          this.setState({
            isLoadedReception: true,
            error
          });
        }
      );
  }

  handleRoomUpdated(room) {
    const { rooms } = this.state;
    const index = rooms.findIndex(r => r.id === room.id);
    rooms[index] = room;
    this.setState({rooms});
  }

  handleCubiclesUpdated(cubicles) {
    this.setState({cubicles});
  }

  retrieveSections() {
    getSections()
      .then(
        result => {
          this.setState({
            isLoadedSections: true,
            sections: result,
          });
        },
        error => {
          this.setState({
            isLoadedSections: false,
            error
          });
        }
      );
    this.sectionRefresh = setTimeout(()=>this.retrieveSections(), 10*60*1000);
  }
  
  retrieveReservations() {
    getReservations()
      .then(
        result => {
          let reservations = result;

          this.setState({
            reservations: reservations,
            isLoadedReservations: true,
            errorReservations: null,
          });
        },
        error => {
          this.setState({
            isLoadedReservations: false,
            errorReservations: error
          });
        }
      );
  }

  playNotificationSound(isReadyMikvah) {
    const {settings} = this.context;
    if(settings&&settings.attendantsBeepNewTaskOnReception&&settings.attendantsBeepNewTaskOnReception.value==="True"){
      if((settings.reservationsCheckingBeforeReadyForMikvah && settings.reservationsCheckingBeforeReadyForMikvah.value==="True")&&isReadyMikvah){
        return false;
      } else{
        this.notificationSound.play();
      }
    }
  }

  render() {
    const RoomTilesCustom = this.props.roomTiles;
    const { isLoadedRooms, isLoadedCubicles, isLoadedReservations, isLoadedSections, isLoadedActiveReception, errorReservations, rooms, cubicles, reservations, error, sections, activeReception, groupedRooms, updatedRooms } = this.state;
    let activeCubicleCount = cubicles?cubicles.filter(s=>['Occupied', 'Assigned'].includes(s.effectiveStatus)).length:0;
    const { settings } = this.context;

    return (
      <div>
        <SignalR setReception={true} onRoomsUpdated={(s) => this.retrieveRooms(s)} onSectionsUpdated={() => this.retrieveSections()} onReservationsUpdated={() => this.retrieveReservations()} onCubiclesUpdated={() => this.retrieveCubicles()} onReceptionUpdated={() => this.retrieveActiveReception()} onNewSupplyRequest={() => this.playNotificationSound()} onNewReadyForMikvah={() => this.playNotificationSound(true)} onNewReadyForChecking={() => this.playNotificationSound()}/>
        <div className={'container-page view-map view-receptionist-map ' + (this.props.receptionistMapShowFullHeight?"fullScreenHeight":"")}>
          <div className="container-main">
            <div className="container-body">
              <SettingsContext.Consumer>
                {({settings}) =>
                  this.props.roomTiles?
                  <RoomTilesCustom receptionistView={true} reservations={reservations} groupedRooms={groupedRooms} updatedRooms={updatedRooms} rooms={rooms} isLoadedRooms={isLoadedRooms} cubicles={cubicles} isLoadedCubicles={isLoadedCubicles} error={error} isLoadedSections={isLoadedSections} sections={sections} isLoadedActiveReception={isLoadedActiveReception} activeReception={activeReception} handleRoomUpdated={(r) => this.handleRoomUpdated(r)} handleCubiclesUpdated={(r) => this.handleCubiclesUpdated(r)} activeCubicleCount={activeCubicleCount} time={this.state.time} settings={settings} />
                  :                
                  <RoomTiles receptionistView={true} reservations={reservations} groupedRooms={groupedRooms} updatedRooms={updatedRooms} rooms={rooms} isLoadedRooms={isLoadedRooms} cubicles={cubicles} isLoadedCubicles={isLoadedCubicles} error={error} isLoadedSections={isLoadedSections} sections={sections} isLoadedActiveReception={isLoadedActiveReception} activeReception={activeReception} handleRoomUpdated={(r) => this.handleRoomUpdated(r)} handleCubiclesUpdated={(r) => this.handleCubiclesUpdated(r)} activeCubicleCount={activeCubicleCount} time={this.state.time} settings={settings} />
                }
              </SettingsContext.Consumer>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ReceptionistMapView;
